import axios from "axios"

import {ApiCallService, apiRequest} from "@libs/ClientService"
import {IGame, IGamePlay, ILabelSet, IQuestion, QuestionField, TGameModes, Vote} from "@backend/types/modules"

export type PickedGame = Pick<IGame, "_id" | "info" | "voteOptions"> & {
    modeOptions: {
        mode: TGameModes,
        fields: QuestionField[],
        questionIds: IQuestion[]
    }
    labelOptions: {
        setId: ILabelSet
    }
}

export type GameStartType = {
    gamePlay?: IGamePlay,
    game: PickedGame
}

export type GamePreviewType = {
    game: PickedGame
}

class GamePlayAPIService extends ApiCallService<IGamePlay> {
    constructor() {
        super("gamePlay")
    }

    start = (gameId: string) => apiRequest<GameStartType>(axios.get(`${this.resourceUrl}/start/${gameId}`))

    endGame = (gamePlayId: string) => apiRequest<string>(axios.get(`${this.resourceUrl}/endGame/${gamePlayId}`))

    preview = (gameId: string) => apiRequest<GamePreviewType>(axios.get(`${this.resourceUrl}/preview/${gameId}`))

    saveFeedback = (gamePlayId: string, questionId: string, message: string) => apiRequest<string>(axios.post(`${this.resourceUrl}/${gamePlayId}/feedback`, {
        questionId,
        message
    }))

    vote = (gamePlayId: string, vote: Vote) => apiRequest<string>(axios.post(`${this.resourceUrl}/${gamePlayId}/vote`, vote))

    voteUpdate = (gamePlayId: string, voteId: string, voteData: any) => apiRequest<number>(axios.put(`${this.resourceUrl}/${gamePlayId}/vote/${voteId}`, voteData))
}

export const gamePlayApiCalls = new GamePlayAPIService()